import React, { useState, useEffect } from 'react';
import './cursos.css';
import api from '../../services/api'; // Importe a API

const CardCurso = ({ titulo, formato, detalhes, preco, onComprar }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className="card-curso"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <h3>{titulo}</h3>
            <p>{formato} - R$ {preco}</p>
            <button onClick={onComprar} className="btn-comprar">Comprar</button>
            <div className={`card-curso-detalhes ${isHovered ? 'visible' : ''}`}>
                <p>{detalhes}</p>
            </div>
        </div>
    );
};

function Cursos() {
    const [listaCursos, setListaCursos] = useState([]);

    useEffect(() => {
        // Busca os produtos cadastrados no backend
        api.get('/products')
            .then((response) => {
                setListaCursos(response.data);
            })
            .catch((err) => console.error("Erro ao buscar cursos", err));
    }, []);

    const handleComprar = (id) => {
        alert(`Lógica de compra para o produto ID: ${id}`);
        // Aqui você chamaria a rota de criar Pedido (Order) futuramente
    };

    return (
        <div className="cursos-container">
            <h2>Por onde começar a aprender?</h2>
            <div className="cards-container">
                {listaCursos.length === 0 ? (
                    <p>Carregando cursos...</p>
                ) : (
                    listaCursos.map((curso) => (
                        <CardCurso
                            key={curso.id}
                            titulo={curso.name}
                            formato={curso.type} // CURSO ou EBOOK
                            detalhes={curso.description}
                            preco={curso.price}
                            onComprar={() => handleComprar(curso.id)}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default Cursos;